export var EPaymentDisputeStatus;
(function (EPaymentDisputeStatus) {
    EPaymentDisputeStatus["TODO"] = "todo";
    EPaymentDisputeStatus["SETTLED"] = "settled";
})(EPaymentDisputeStatus || (EPaymentDisputeStatus = {}));
// Dispute reason types as returned by MangoPay (DisputeReason.DisputeReasonType).
// Stored raw on the dispute and exposed as-is by the API; the friendly label
// mapping lives in utils/paymentDispute.utils.ts.
// The values must match what MangoPay sends, so two of them keep spellings we
// would not write ourselves: "AUTHORISATION" is British, and "REOCCURING" is a
// typo on their side. The member names use US English.
// cspell:ignore authorisation reoccuring
export var EPaymentDisputeReasonType;
(function (EPaymentDisputeReasonType) {
    EPaymentDisputeReasonType["AuthorizationDisputed"] = "AUTHORISATION_DISPUTED";
    EPaymentDisputeReasonType["CanceledRecurringTransaction"] = "CANCELED_REOCCURING_TRANSACTION";
    EPaymentDisputeReasonType["Duplicate"] = "DUPLICATE";
    EPaymentDisputeReasonType["Fraud"] = "FRAUD";
    EPaymentDisputeReasonType["LateFailureBankAccountClosed"] = "LATE_FAILURE_BANKACCOUNT_CLOSED";
    EPaymentDisputeReasonType["LateFailureBankAccountIncompatible"] = "LATE_FAILURE_BANKACCOUNT_INCOMPATIBLE";
    EPaymentDisputeReasonType["LateFailureBankAccountIncorrect"] = "LATE_FAILURE_BANKACCOUNT_INCORRECT";
    EPaymentDisputeReasonType["LateFailureContactUser"] = "LATE_FAILURE_CONTACT_USER";
    EPaymentDisputeReasonType["LateFailureInsufficientFunds"] = "LATE_FAILURE_INSUFFICIENT_FUNDS";
    EPaymentDisputeReasonType["Other"] = "OTHER";
    EPaymentDisputeReasonType["ProductNotProvided"] = "PRODUCT_NOT_PROVIDED";
    EPaymentDisputeReasonType["ProductUnacceptable"] = "PRODUCT_UNACCEPTABLE";
    EPaymentDisputeReasonType["RefundConversionRate"] = "REFUND_CONVERSION_RATE";
    EPaymentDisputeReasonType["RefundNotProcessed"] = "REFUND_NOT_PROCESSED";
    EPaymentDisputeReasonType["TransactionNotRecognized"] = "TRANSACTION_NOT_RECOGNIZED";
    EPaymentDisputeReasonType["Unknown"] = "UNKNOWN";
})(EPaymentDisputeReasonType || (EPaymentDisputeReasonType = {}));
